<!-- 酒店首页 -->
<template>
  <div
    class='hotel_wrap'
    :style="`margin-bottom: ${isfooter ? '60px' : '0'}`"
  >
    <!-- 轮播图 -->
    <CusSiwper
      :list="infos.images"
      :isrank="true"
    />
    <!-- 酒店信息 -->
    <div class="hotel_info_wrap">
      <div class="hotel_info_top">
        <div class="hotel_logo_wrap">
          <img
            class="hotel_logo"
            v-if="infos.logo"
            v-lazy="apiObj.VUE_APP_BASE_CDN + infos.logo"
          >
        </div>

        <div class="hotel_rate_wrap">
          <van-rate
            v-model="infos.star"
            :size="20"
            readonly
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
          />
        </div>
      </div>
      <div class="hotel_name">{{ infos.name }}</div>
      <div class="hotel_info_footer">
        <div class="hotel_info_footer_left">
          <!-- <div class="hotel_position">{{infos.province}}{{infos.city}}{{infos.area}}{{infos.address}}</div> -->
          <div class="hotel_position">{{ infos.address_show ? infos.address_show : `${infos.province + infos.city +
            infos.area + infos.address}` }}</div>

          <div
            class="hotel_contact_wrap"
            v-if="infos.province !== '海外' && infos.city !== '文莱'"
          >
            <div
              class="hotel_navigate"
              :class="is_wx_browser ? '' : 'disable_navigate'"
              @click="handleNavigate"
            >{{ $t('hotel.navigate') }}</div>

            <a
              :href="`tel:${infos.phone}`"
              class="hotel_contact"
            >{{ $t('hotel.contact') }}</a>
            <div
              v-show="infos.is_distance"
              class="hotel_distance"
            >{{ $t('hotel.distance') }} {{ infos.distance }}</div>
          </div>
        </div>
        <div class="hotel_info_footer_right">
          <img
            v-if="infos.province !== '海外' && infos.city !== '文莱'"
            :src="navigate_img"
            @click="handleNavigate"
            class="hotel_navigate_img"
          >
        </div>
      </div>

      <!-- 简介、图集、房型 -->
      <div class="hotel_tab_wrap">
        <van-tabs
          v-model="activeTab"
          title-inactive-color="#777"
          title-active-color="#000"
        >
          <!-- <van-tab
            title="图集"
            name="b"
          >内容 2</van-tab> -->
          <van-tab
            :title="$t('hotel.roomType')"
            name="room"
          >
            <Rooms @listenWannaBook="wannaToBook" />
          </van-tab>

          <van-tab
            :title="$t('hotel.intro')"
            name="intro"
          >
            <div class="tab_content_wrap">
              <RichText :info="infos.introduction" />
              <!-- empty -->
              <CusEmpty
                v-show="infos.introduction == 0"
                :info="$t('global.empty')"
              />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 版权 -->
    <CopyRight v-show="this.$root.isVersion" />

    <!-- 加载 -->
    <CusLoading :show="loading" />

    <!-- 底部按钮 -->
    <RoomFooter
      v-show="isfooter"
      :price="infos.reserve_price"
      :marketprice="infos.market_price"
      :currency="currency"
      :ismarketprice="is_market_price"
      @listenwannaPickRoom="wannaPickRoom"
    />

    <!-- 提示弹框 -->
    <CusDialog
      :show="isshowdialog"
      :title="$t('global.dialogTitle')"
      :info="$t('hotel.navigateTips')"
      :confirmText="$t('hotel.confirmText')"
      @listenCloseDialog="wannaloseDialog"
    />
    <BackBtn />
  </div>
</template>

<script>
import Vue from 'vue'
import { Rate, Lazyload, Tab, Tabs } from 'vant'

Vue.use(Rate)
Vue.use(Lazyload)
Vue.use(Tab)
Vue.use(Tabs)

import CusSiwper from '@c/CusSiwper'
import apiObj from '@a/js/api.js'
import RichText from '@c/RichText'
import Rooms from './comp/Rooms'
import CusLoading from '@c/CusLoading'
import CopyRight from '@c/CopyRight'
import RoomFooter from './comp/RoomFooter.vue'
import CusDialog from './comp/CusDialog.vue'
import CusEmpty from '@c/CusEmpty'
import BackBtn from '@c/BackBtn'

import { SimpleQicukSort } from '@a/js/utils.js'
import { GetHotelInfo, GetTotalOptions } from '@a/js/api/booking.js'

import { SetWechatShare } from '@a/js/utils'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'
import { GetVersionOption, GetWxshareConfig } from '@a/js/api/public'
export default {
  name: 'Hotel',
  data() {
    return {
      apiObj,
      loading: true,
      activeTab: 'room',
      currency: '￥',
      is_market_price: 0,
      infos: {},
      navigate_img: require('@a/img/hotel/map.png'),
      is_wx_browser: false,
      isshowdialog: false,

    };
  },

  computed: {
    isfooter() {
      return this.activeTab != 'room'
    }
  },

  components: {
    CusSiwper,
    RichText,
    Rooms,
    CusLoading,
    CopyRight,
    RoomFooter,
    CusDialog,
    CusEmpty,
    BackBtn
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 查询酒店信息
    initHotelInfo() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        hotel_uid: this.params.hotelid
      }
      GetHotelInfo(data, this.$root.language).then(res => {
        // console.log(res.data)
        this.infos = res.data
        this.infos.images = SimpleQicukSort(res.data.cover)
        this.loading = false
      }).catch(() => { })
    },
    // 获取整体配置
    wannaTotalOpt() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        fields: [
          "is_market_price",
          "currency",
          "theme"
        ]
      }
      GetTotalOptions(data, this.$root.language).then(res => {
        // console.log(res.data)
        this.currency = res.data.currency
        this.is_market_price = res.data.is_market_price
        this.initThemeOpt(res.data.theme)
      }).catch(() => { })
    },
    // 点击选择房型
    wannaPickRoom() {
      this.activeTab = 'room'
    },
    // 设置主体颜色
    initThemeOpt(info) {
      document.body.style.setProperty('--background', info.background)
      document.body.style.setProperty('--color', info.color)
    },
    // 点击预订酒店
    wannaToBook(info) {
      let infos = info
      infos.accountid = this.params.accountid
      infos.projectid = this.params.projectid
      infos.hotelid = this.params.hotelid
      infos.hotel_name = this.infos.name
      this.$storeLocal.set('cbooking_good', infos)
      this.$router.push({
        name: "Book",
        params: {
          accountid: this.params.accountid,
          projectid: this.params.projectid,
          hotelid: this.params.hotelid,
          roomid: infos.roomid,
          goodid: infos.goodid,
          language: this.$i18n.locale
        }
      })
    },
    // 初始化版权信息
    initVersionOption() {
      let data = {
        account_uid: this.params.accountid,
        app_name: 'version',
        type: 4
      }
      GetVersionOption(data).then(res => {
        this.$root.isVersion = res.data.is_version
      }).catch(() => { })
    },
    // 页面初始化获取微信分享配置
    InitWxShareConfig() {
      let href = window.location.href.split('#')[0]

      let resdata = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        url: Base64.encode(href),
      }
      GetWxshareConfig(resdata)
        .then((res) => {
          // console.log(res)
          if (res.data.config.appId) {
            let imgUrl = ''
            if (res.data.info.img.length > 0) {
              imgUrl = apiObj.VUE_APP_BASE_CDN + res.data.info.img
            }
            SetWechatShare(wx, res.data, href, imgUrl)
          }
        })
        .catch(() => { })
    },
    // 判断是否微信浏览器
    judgeIsWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // return true;
        this.is_wx_browser = true
      } else {
        // return false;
        this.is_wx_browser = false
      }
    },
    // 点击导航按钮
    handleNavigate() {
      // console.log('wanna navigate')
      if (this.is_wx_browser) {
        wx.openLocation({
          latitude: parseFloat(this.infos.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.infos.lng), // 经度，浮点数，范围为180 ~ -180。
          name: this.infos.name, // 位置名
          address: this.infos.province + this.infos.city + this.infos.area + this.infos.address, // 地址详情说明
          scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
          infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
          success: () => {
            // console.log('success')
          },
          fail: (err) => {
            console.log(err)
          }
        })
      } else {
        this.isshowdialog = true
      }

    },
    // 关闭弹框
    wannaloseDialog() {
      this.isshowdialog = false
    }

  },

  mounted() {
    this.judgeIsWeiXin()
    this.GetParamsData().then(() => {
      this.initVersionOption()
      this.InitWxShareConfig()
      this.wannaTotalOpt()
      this.initHotelInfo()
    })
  },
}
</script>
<style lang='less' scoped>
.hotel_wrap {
  position: relative;

  .hotel_info_wrap {
    padding: 15px 15px 0;

    .hotel_info_top {
      display: flex;
      margin-bottom: 15px;

      .hotel_logo_wrap {
        flex: 1;
        font-size: 0;

        .hotel_logo {
          height: 20px;
        }
      }

      .hotel_rate_wrap {
        height: 20px;
        line-height: 20px;
      }
    }

    .hotel_name {
      font-size: 20px;
      line-height: 28px;
      font-weight: 700;
      letter-spacing: 0.01em;
      margin-bottom: 10px;
    }

    .hotel_info_footer {
      display: flex;
      margin-bottom: 10px;

      .hotel_info_footer_left {
        flex: 1;

        .hotel_position {
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: #777;
          margin-bottom: 5px;
          margin-top: 5px;
        }

        .hotel_contact_wrap {
          font-size: 0;

          .hotel_navigate,
          .hotel_distance {
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.01em;
            color: #06f;
            display: inline-block;
            font-weight: 700;
          }

          .disable_navigate {
            color: #777;
          }

          .hotel_distance {
            color: #777;
            font-weight: 400;
          }

          .hotel_contact {
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.01em;
            color: #06f;
            margin: 0 15px;
            font-weight: 700;
          }
        }
      }

      .hotel_info_footer_right {
        display: flex;
        align-items: center;
        margin-left: 15px;

        .hotel_navigate_img {
          width: 50px;
          height: 50px;
        }
      }
    }

    .hotel_tab_wrap {
      .tab_content_wrap {
        padding-top: 15px;
        box-sizing: border-box;
        // 含版权
        min-height: calc(~"100vh - 555px");
      }

      :v-deep .van-tab--active {
        font-weight: 700;
      }

      :v-deep .van-tabs__line {
        background: #000;
      }
    }
  }
}
</style>
